// extracted by mini-css-extract-plugin
export default {"defaultControl":"defaultControl---XH_YI"};